const ELLIPSIS = '...';

/**
 * Truncates the local part of an email address with specified replacement when it exceeds
 * the maximum number of characters.
 *
 * E.g. `thisisaverylongemail@example.org` becomes `thisisaverylo...@example.com`.
 */
export default (email, maxChars, replacement = ELLIPSIS) => {
	if (!email || email.length <= maxChars) {
		return email;
	}

	const [local, domain] = email.split('@');
	const max = maxChars - domain.length - replacement.length - 1; // -1 for @
	return `${local.substring(0, max)}${ELLIPSIS}@${domain}`;
};
